import { ChakraProvider } from "@chakra-ui/react";
import { configureStore } from "configureStore";
import "core-js";
import "polyfill";
import React from "react";
import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import themeController from "themeController";
import App from "./App";
import "./util/i18n";

const initialState: any = {};
const store = configureStore(initialState);

themeController("teams");

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ChakraProvider>
        <App />
      </ChakraProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
